<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_465')}}</div>
    <div slot="body">
      <a-form
        :form="form.fc"
        @submit="handleConfirm">
        <a-form-item
          :label="$t('scope.text_861')"
          v-bind="formItemLayout">
          ￥{{ billAccountInfo.balance }}
        </a-form-item>
        <a-form-item
          :label="$t('scope.text_862')"
          v-bind="formItemLayout">
          <a-input-number
            class="w-25"
            v-decorator="decorators.money"
            :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="value => value.replace(/\￥\s?|(,*)/g, '')"
            :precision="2" />
            <template #extra>
              <div class="desc">{{$t('scope.text_863')}}<router-link :to="{ path: '/income-expenditure-details' }">{{$t('scope.text_275')}}</router-link></div>
            </template>
        </a-form-item>
        <a-form-item required>
          <a-checkbox style="width: 100%;" v-model="isAgree">{{$t('scope.recharge_agreement')}}</a-checkbox>
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading" :disabled="!isAgree">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{$t('scope.text_457')}}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapState } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'RechargeAmountDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this, {}),
      },
      formItemLayout: {
        wrapperCol: {
          span: 21,
        },
        labelCol: {
          span: 3,
        },
      },
      isAgree: false,
      decorators: {
        money: [
          'money',
          {
            validateFirst: true,
            rules: [
              { required: true, message: this.$t('scope.text_857') },
              { validator: this.checkMoney },
            ],
          },
        ],
      },
    }
  },
  computed: {
    ...mapState('app', {
      customer: state => state.customer,
      billAccountInfo: state => state.billAccountInfo,
    }),
  },
  methods: {
    checkMoney (rule, value, callback) {
      if (value.toString().indexOf('-') >= 0) {
        const error = this.$t('scope.text_860')
        callback(error)
      } else {
        callback()
      }
    },
    async handleConfirm (e) {
      e.preventDefault()
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        this.$router.push({ path: '/account/checkout', query: { charge_amount: values.money, from: this.params.from } })
        this.cancelDialog()
        this.loading = false
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>

<style lang="less" scoped>
  .recharge-amount {
    .money {
      color: #4DA1FF;
    }
    .desc {
      font-size: 12px;
      line-height: 32px;
    }
    .pay-type {
      list-style: none;
      padding: 0;
      .pay-type-item {
        width: 860px;
        cursor: pointer;
        border-width: 1px;
        border-style: solid;
        border-color: rgb(215, 216, 217);
        border-image: initial;
        .radio-box {
          padding: 12px 16px;
          .radio {
            display: inline-block;
          }
          .radio-text {
            display: inline-block;
            vertical-align: top;
            font-size: 18px;
            .ali-icon {
              font-size: 22px;
            }
          }
        }
      }
      .pay-type-current {
        border-width: 2px;
        border-style: solid;
        border-color: rgb(255, 166, 0);
        border-image: initial;
      }
    }
    ::v-deep {
      .ant-checkbox-wrapper {
        color: rgb(115, 119, 122);
        font-size: 14px;
      }
      .ant-form-item {
        margin-bottom: 0;
        .ant-input-number {
          width: 100%;
        }
      }
    }
  }
</style>
